<template>
    <div>
        <b-alert variant="warning" v-if="deposits.length <= 0" class="mb-2 p-1">
            <p class="mb-0">Personele ait ödeme bekleyen herhangi bir emanet kaydı bulunmamaktadır.</p>
        </b-alert>

        <div v-if="deposits.length > 0" class="col-12 mb-2 border rounded p-1 mt-50 bg-light-secondary">
            <div class="d-flex justify-content-between align-items-center">
                <h5 class="mb-0 font-weight-bolder text-secondary">
                    <feather-icon icon="ArchiveIcon" class="mr-50" />
                    Toplam Emanet Bakiyesi
                </h5>
                <h5 class="mb-0 font-weight-bolder text-secondary">{{ totalDeposits.toLocaleString("tr-TR", { style: "currency", currency: "TRY" }) }}</h5>
            </div>

            <hr class="my-75 border-secondary" />

            <div>
                <div v-for="deposit in deposits" :key="deposit.Id" class="d-flex align-items-center justify-content-between mb-50">
                    <span class="d-flex align-items-center">
                        <feather-icon icon="TagIcon" size="14" class="mr-50" />
                        {{ deposit.RefNumber }}
                    </span>
                    <span class="font-weight-bold">{{ deposit.AmountStr }}</span>
                </div>
            </div>
        </div>
        <v-mu-picker ref="picker" :code="$safe(muhasebe, 'MuhasebeKodu')" v-on:pick="onPickMuhasebe" />
        <div class="row">
            <div class="col-12 mb-1">
                <label class="form-label">Tahsil Edilebilen Tutar</label>
                <v-validator :errors="errors" parameter="Amount" :watch="model.Amount">
                    <v-currency-input
                        input-class="text-right"
                        :value="model.Amount"
                        v-on:update-value="(amount) => (model.Amount = amount)"
                        :disabled="!deposits.length"
                        placeholder="0,00"
                    ></v-currency-input>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Kasa</label>
                <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                    <v-select-list v-model="kasa" :options="kasaList" v-on:input="getPairList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Gelir/Gider</label>
                <v-validator :errors="errors" parameter="VaultActionType" :watch="gcType">
                    <v-select-list v-model="gcType" label="Name" :options="gcTypes" placeholder="Gelir/Gider" :disabled="true"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Tarih</label>
                <v-validator :errors="errors" parameter="EffectiveDate" :watch="model.EffectiveDate">
                    <v-date-picker v-model="model.EffectiveDate" placeholder="Tarih" :disabled="true" />
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Muhasebe Kodu</label>
                <div class="d-flex g-50">
                    <v-validator :errors="errors" parameter="MuhasebeKarsilikKodu" :watch="muhasebe">
                        <v-select-list :disabled="(pairList || []).length <= 1 || kasa == null" v-model="model.MuhasebeKodu" :options="pairList" placeholder="Muhasebe Kodu"></v-select-list>
                    </v-validator>
                </div>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Proje Kodu</label>
                <v-validator :errors="errors" parameter="ProjectCode" :watch="projectCode">
                    <v-select-list v-model="projectCode" :options="projectCodes" label="label" placeholder="Proje Kodu" :disabled="true"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Kasa Rapor Açıklama</label>
                <v-validator :errors="errors" parameter="KasaRapor_Kodu" :watch="reportCode">
                    <v-select-list v-model="reportCode" :options="reportCodes" label="Code" placeholder="Kasa Rapor Açıklama" :disabled="true"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Kasa Açıklaması</label>
                <v-validator :errors="errors" parameter="VaultDescription" :watch="model.VaultDescription">
                    <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Kasa Açıklaması" v-model="model.VaultDescription" :disabled="true"></textarea>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">TMS Kasa Açıklaması</label>
                <v-validator :errors="errors" parameter="TMSVaultDescription" :watch="model.TMSVaultDescription">
                    <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="TMS Kasa Açıklaması" v-model="model.TMSVaultDescription" :disabled="true"></textarea>
                </v-validator>
            </div>
            <div class="col-12 mb-1">
                <label class="form-label">Belge Türü</label>
                <v-validator :errors="errors" parameter="BelgeTuru" :watch="belgeTuru">
                    <v-select-list :options="belgeTurus" label="Name" placeholder="Belge Türü" v-model="belgeTuru" :disabled="true"></v-select-list>
                </v-validator>
            </div>
            <div class="col-12 text-right">
                <v-executer :loading="saveLoading" :action="save"> Kaydet </v-executer>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import NetsisOperationsApi from "@/api/netsis-operations";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VExecuter from "@/components/VExecuter.vue";
import moment from "moment";
import VMuPicker from "@/components/VMuPicker.vue";

export default {
    components: {
        BCard,
        VCurrencyInput,
        VExecuter,
        VMuPicker,
    },
    props: {
        initialData: {
            type: Object,
            default: () => ({}),
        },
        deposits: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            errors: {},
            saveLoading: false,
            projectCodes: [
                { value: "R", label: "Banka 1" },
                { value: "G", label: "Banka 2" },
            ],
            pairList:[],
            gcTypes: [
                { Name: "Gelir", Value: "G" },
                { Name: "Gider", Value: "C" },
            ],
            muhasebe: null,
            reportCodes: [],
            belgeTurus: [],
            kasaLoading: false,
            kasaList: [],
            model: {
                Amount: 0,
                ProjectCode: null,
                VaultActionType: null,
                VaultCode: null,
                VaultDescription: null,
                EffectiveDate: moment().format("YYYY-MM-DD"),
                MuhasebeKarsilikKodu: null,
                KasaRaporKodu: null,
                TMSVaultDescription: null,
                BelgeTuru: null,
            },
        };
    },
    computed: {
        gcType: {
            get() {
                return this.gcTypes.find((s) => s.Value == this.model.VaultActionType);
            },
            set(value) {
                this.model.VaultActionType = value?.Value || null;
            },
        },
        kasa: {
            get() {
                return this.kasaList.find((s) => s.KSMAS_KOD == this.model.VaultCode);
            },
            set(value) {
                this.model.VaultCode = value?.KSMAS_KOD || null;
            },
        },
        projectCode: {
            get() {
                return this.projectCodes.find((s) => s.value == this.model.ProjectCode);
            },
            set(value) {
                this.model.ProjectCode = value?.value || null;
            },
        },
        reportCode: {
            get() {
                return this.reportCodes.find((s) => s.Code == this.model.KasaRaporKodu);
            },
            set(value) {
                this.model.KasaRaporKodu = value?.Code || null;
            },
        },
        belgeTuru: {
            get() {
                return this.belgeTurus.find((s) => s.Name == this.model.BelgeTuru);
            },
            set(value) {
                this.model.BelgeTuru = value?.Name || null;
            },
        },
        totalDeposits() {
            if (!this.deposits || this.deposits.length === 0) return 0;
            return this.deposits.reduce((acc, deposit) => acc + deposit.Amount, 0);
        },
    },
    watch: {
        initialData: {
            handler(newData) {
                if (newData) {
                    this.model.Amount = newData.Amount || 0;
                    this.model.VaultActionType = newData.VaultActionType || "G";
                    this.model.ProjectCode = newData.ProjectCode || "G";
                    this.model.EffectiveDate = newData.EffectiveDate || moment().format("YYYY-MM-DD");
                    this.model.VaultDescription = newData.VaultDescription || null;
                    this.model.TMSVaultDescription = newData.TMSVaultDescription || null;
                }
            },
            immediate: true,
            deep: true,
        },
        reportCodes: {
            handler(newCodes) {
                if (newCodes && newCodes.length > 0) {
                    const vukuatTahsilati = newCodes.find((c) => c.Code === "Vukuat Tahsilatı");
                    if (vukuatTahsilati) {
                        this.model.KasaRaporKodu = vukuatTahsilati.Code;
                    }
                }
            },
            immediate: true,
        },
        belgeTurus: {
            handler(newTurus) {
                if (newTurus && newTurus.length > 0) {
                    const muhtelif = newTurus.find((t) => t.Name === "Muhtelif");
                    if (muhtelif) {
                        this.model.BelgeTuru = muhtelif.Name;
                    }
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.getKasaList();
        this.getReportCodes();
        this.getBelgeTurus();
    },
    methods: {
        getPairList(){
            if(this.model.VaultCode){
                this.pairList = []
                this.model.MuhasebeKodu = null
                NetsisOperationsApi.AccountPair.List(this.model.VaultCode).then(res => {
                    if(res.data.Success){
                        this.pairList = (res.data.Data || []).map(s => s.Key)
                        if((res.data.Data || []).length == 1){
                            this.model.MuhasebeKodu = (res.data.Data || [])[0]?.Key || null
                        }
                    }
                })
            }else {
                this.pairList = []
                this.model.MuhasebeKodu = null
            }
        },
        getKasaList() {
            this.kasaLoading = true;
            NetsisOperationsApi.GetKasaList()
                .then((res) => {
                    this.kasaList = res.data.Data;
                    this.kasaLoading = false;
                })
                .catch(() => {
                    this.kasaLoading = false;
                });
        },
        save() {
            this.saveLoading = true;
            NetsisOperationsApi.SaveMuhtelifKasaHareket(this.model)
                .then((res) => {
                    this.$result(res);
                    this.saveLoading = false;
                    if (res.data.Success) {
                        this.$emit("saveSuccess", this.model);
                    }
                })
                .catch((err) => {
                    this.saveLoading = false;
                    this.$result(null, err);
                });
        },
        getReportCodes() {
            NetsisOperationsApi.ReportCode.List().then((res) => {
                if (res.data.Success) {
                    this.reportCodes = res.data.Data || [];
                }
            });
        },
        getBelgeTurus() {
            NetsisOperationsApi.BelgeTuru.List().then((res) => {
                this.belgeTurus = res.data.Data || [];
            });
        },
        onPickMuhasebe(e) {
            // this.model.VaultDescription = e?.MuhasebeAdi || this.model.VaultDescription;
            this.model.MuhasebeKarsilikKodu = e?.MuhasebeKodu || null;
            this.muhasebe = e;
        },
    },
};
</script>
